<script lang="ts" setup>
import ChevronLeft16Icon from 'assets/icons/arrows/16/chevron-left.svg?component'
import useCatalogStore from '~/shared/store/modules/catalog'
import {
  onAccordionTransitionEnter,
  onAccordionTransitionLeave,
  onAccordionAfterEnter,
} from '~/components/ui/accordion/accordion-script'

defineProps<{
  isWithoutTitle?: boolean
}>()

const emits = defineEmits(['click-link'])

const catalogStore = useCatalogStore()
const route = useRoute()

const catalogBreadcrumbsSlugList = catalogStore.catalogBreadcrumbs.map(
  (slug) => slug.slug
)
const pathList: string[] = []
const showFullCategoriesList = ref(false)

for (let i = 0; i < catalogBreadcrumbsSlugList.length; i++) {
  pathList.push(
    catalogBreadcrumbsSlugList
      .slice(0, catalogStore.catalogBreadcrumbs.length - i)
      .join('/')
  )
}

pathList.reverse()

const getCategoriesAccordionActionText = computed(() => {
  const { closed, opened } = {
    closed: 'Показать ещё',
    opened: 'Скрыть',
  }

  if (showFullCategoriesList.value) {
    return opened
  } else {
    return closed
  }
})

function getPath(newSlug: string) {
  const currentSlugList = [...route.params.slug]
  currentSlugList[currentSlugList.length - 1] = newSlug

  return currentSlugList.join('/')
}

function setCategoriesVisibility() {
  showFullCategoriesList.value = !showFullCategoriesList.value
}

const clickLink = () => emits('click-link')
</script>

<template>
  <div class="categories">
    <div class="categories-title" v-if="!isWithoutTitle">Категории</div>
    <ul class="categories-list">
      <li
        v-for="(prevCategory, i) in catalogStore.catalogBreadcrumbs"
        class="categories-list__link-wrapper"
      >
        <NuxtLink
          class="categories-list__link categories-list__link_breadcrumb"
          :to="'/catalog/' + pathList[i]"
          v-if="i !== catalogStore.catalogBreadcrumbs.length - 1"
          @click="clickLink"
        >
          <ChevronLeft16Icon />
          {{ prevCategory.name }}
        </NuxtLink>
        <div class="categories-list__link categories-list__link_current" v-else>
          {{ prevCategory.name }}
        </div>
      </li>
      <!--TODO: ↓↓↓ я не понял что, но когда там определятся со структурой каталога, нужно будет переделать ↓↓↓-->
      <!--      <template v-for="(category, i) in catalogStore.prevCategories">-->
      <!--        <Transition-->
      <!--          name="accordion-item"-->
      <!--          @enter="onAccordionTransitionEnter"-->
      <!--          @leave="onAccordionTransitionLeave"-->
      <!--          @after-enter="onAccordionAfterEnter"-->
      <!--        >-->
      <!--          <li-->
      <!--            v-show="i <= 4 || showFullCategoriesList"-->
      <!--            class="categories-list__link-wrapper"-->
      <!--          >-->
      <!--            <NuxtLink-->
      <!--              class="categories-list__link"-->
      <!--              :to="'/catalog/' + getPath(category.slug)"-->
      <!--            >-->
      <!--              {{ category.name }}-->
      <!--            </NuxtLink>-->
      <!--          </li>-->
      <!--        </Transition>-->
      <!--      </template>-->
      <!--      <li-->
      <!--        v-if="catalogStore.prevCategories && catalogStore.prevCategories.length > 5"-->
      <!--        @click="setCategoriesVisibility"-->
      <!--        class="categories-list__accordion-wrapper"-->
      <!--      >-->
      <!--        <span class="categories-list__accordion-action">-->
      <!--          {{ getCategoriesAccordionActionText }}-->
      <!--        </span>-->
      <!--      </li>-->
    </ul>
  </div>
</template>
<style lang="scss" scoped>
.categories {
  &-title {
    @include font(16px, 20px, 500);
  }
  &-list {
    margin-top: 8px;
    &__accordion {
      &-wrapper {
        padding: 8px 10px;
      }
      &-action {
        cursor: pointer;
        color: $control-content_orange;
        @include font(14px, 20px, 400);

        &:hover:not(:active) {
          color: $control-content_orange;
        }
      }
    }
    &__link {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 8px 10px;
      border-radius: 8px;
      background-color: transparent;
      color: $content_primary;
      transition: 0.3s color;
      @include font(14px, 20px);

      &:hover:not(.categories-list__link_current) {
        color: $control-content_orange;
      }

      &_current {
        background-color: $bg_neutral;
      }

      &_breadcrumb {
        padding-left: 0;
        transition: 0.2s color;
        &:hover {
          background-color: transparent;
          color: $control-content_orange;
          &:deep(path) {
            fill: $control-content_orange;
          }
        }
      }
    }
  }
}
</style>
